import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { CellFunction, DirectCell, TooltipHeader } from '../../cells';
import { IEpxCareGiver } from '../../../../../libs/apps/epxcaregiver';

const TOOLTIPS = {
  ITP: 'Intention To Place – 1) Definitely not 2) Probably not 3) Probably would 4) Definitely would 5) Does not apply- relative is in care facility',
  ID1: 'The things I am responsible for do not fit very well with what I want to do. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree',
  ID2: 'I am not always able to be the person I want to be when I am with my care receiver. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree',
  ID3: 'It is difficult for me to accept the responsibilities that I now have to assume. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree',
  ID4: 'It is difficult for me to accept all the responsibility for my care receiver. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree',
  ID5: 'I am having trouble accepting the way I relate to my care receiver. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree',
  ID6: 'I am not sure that I can accept any more responsibility than I have right now. 1) Strongly Disagree 2) Disagree 3) Disagree A Little 4) Agree A Little 5) Agree 6) Strongly Agree'
};

const EpxCareGiverTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxCareGiver>[] = [
    {
      Header: 'Mood',
      id: 'mood',
      Cell: ResponseGuard(DirectCell('mood') as CellFunction<IEpxCareGiver>)
    },
    {
      Header: TooltipHeader('ITP', TOOLTIPS['ITP']),
      id: 'intentionToPlace',
      Cell: ResponseGuard(
        DirectCell('intentionToPlace') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID1', TOOLTIPS['ID1']),
      id: 'discrepancyOne',
      Cell: ResponseGuard(
        DirectCell('discrepancyOne') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID2', TOOLTIPS['ID2']),
      id: 'discrepancyTwo',
      Cell: ResponseGuard(
        DirectCell('discrepancyTwo') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID3', TOOLTIPS['ID3']),
      id: 'discrepancyThree',
      Cell: ResponseGuard(
        DirectCell('discrepancyThree') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID4', TOOLTIPS['ID4']),
      id: 'discrepancyFour',
      Cell: ResponseGuard(
        DirectCell('discrepancyFour') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID5', TOOLTIPS['ID5']),
      id: 'discrepancyFive',
      Cell: ResponseGuard(
        DirectCell('discrepancyFive') as CellFunction<IEpxCareGiver>
      )
    },
    {
      Header: TooltipHeader('ID6', TOOLTIPS['ID6']),
      id: 'discrepancySix',
      Cell: ResponseGuard(
        DirectCell('discrepancySix') as CellFunction<IEpxCareGiver>
      )
    }
  ];
  return (
    <SessionTable<IEpxCareGiver>
      url="/epxcaregiver/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxCareGiverTable;
